module.exports = __webpack_public_path__ + "static/media/jacinda-shelly.45f99ae6.png";